import './app.css';
import App from './App.svelte';
import { mount } from 'svelte';

const app = mount(App, {
  target: document.getElementById('app')!
});

// Installability is a progressive enhancement, not a prerequisite for login.
// Do not register in Vite development, where a worker could intercept HMR.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.warn('CRM service worker registration failed:', error);
    });
  });
}

export default app;
